module.exports = __webpack_public_path__ + "img/microsite-MY.dad3eece.gif";